import { round } from 'lodash'

const getAverage = (list) => {
	const somme = list.reduce((a, b) => {
		return a + b
	}, 0)
	return round((somme / list.length), 2)
}

export { getAverage }



// WEBPACK FOOTER //
// ./src/utils/MathUtil.js